export enum WidgetBackgroundColor {
	DEFAULT = 'default',
	NONE = 'none'
}